import React from "react";
import { classNames } from "repoV2/utils/common/render/classNames";
import { useMainCtaButtonContext } from "repoV2/pages/sale/contexts/MainCtaButtonContext";
import { Button } from "repoV2/components/common/Button";
import { getUnitsToShow } from "repoV2/utils/common/time/countDownTimer";
import { useCountdownTimerSection } from "../../../../utils/common/useCountdownTimerSection";
import { useTemplate3Context } from "../../Template3Context";
import styles from "./CountdownTimerSection.module.scss";
import commonStyles from "../../common.module.scss";
import { CountdownTimer } from "./CountdownTimer/CountdownTimer";

const CountdownTimerSection = () => {
    const { theme } = useTemplate3Context();
    const { hide, units, timeIsRunningOutText, hurryText } =
        useCountdownTimerSection();
    const {
        ctaText,
        strikedOffText,
        onMainCtaClick,
        hide: hideCtaButton,
    } = useMainCtaButtonContext();

    const unitsToShow = getUnitsToShow({
        allUnits: units,
        timerEnded: hide,
        noOfTimeUnitsToShow: 4,
    });

    if (hide) return null;

    return (
        <div style={{ background: theme.colors.color6 }}>
            <div
                className={classNames(
                    commonStyles.section,
                    styles.section,
                    commonStyles.maxWidthContainer
                )}
            >
                {timeIsRunningOutText ? (
                    <div
                        className={classNames(
                            styles.timeIsRunningOutText,
                            "text-center word-break"
                        )}
                        style={{ color: theme.colors.color4 }}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: timeIsRunningOutText,
                        }}
                    />
                ) : null}

                <CountdownTimer units={unitsToShow} />
                {!hideCtaButton ? (
                    <Button
                        onClick={onMainCtaClick}
                        className={classNames(styles.mainCtaButton)}
                        style={{
                            background: `linear-gradient(270deg, ${theme.colors.color1} 14.14%, ${theme.colors.color2} 89.56%)`,
                            color: theme.colors.color10,
                        }}
                    >
                        {ctaText}
                        {strikedOffText ? (
                            <span className="small">
                                &nbsp;<del>{strikedOffText}</del>
                            </span>
                        ) : null}
                    </Button>
                ) : null}
                {hurryText ? (
                    <div
                        className={classNames(
                            styles.hurryText,
                            "text-center word-break"
                        )}
                        style={{ color: theme.colors.color4 }}
                        // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: hurryText,
                        }}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default CountdownTimerSection;
